var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLyssna = function SvgLyssna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 25,
    viewBox: "0 0 16 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00263E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.358 16.304c-2.13 0-3.861-1.749-3.861-3.899a3.9 3.9 0 0 1 3.02-3.805c-.316-1.535-1.665-2.693-3.278-2.693-1.845 0-3.347 1.516-3.347 3.38H4.348c0-2.724 2.194-4.94 4.891-4.94s4.891 2.216 4.891 4.94v.78h-.772c-1.278 0-2.317 1.048-2.317 2.338s1.04 2.34 2.317 2.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.045 22.396a2.63 2.63 0 0 1-2.208-1.19l-5.07-7.75a6.96 6.96 0 0 1-1.137-3.82c0-3.878 3.185-7.032 7.1-7.032a7.11 7.11 0 0 1 5.785 2.95v-3.63A9.68 9.68 0 0 0 9.73 0C4.365 0 0 4.323 0 9.635c0 1.867.54 3.678 1.561 5.237l5.069 7.75A5.26 5.26 0 0 0 11.045 25c2.9 0 5.26-2.336 5.26-5.208h-2.63c0 1.436-1.18 2.604-2.63 2.604"
  }))));
};
export default SvgLyssna;